import { NylasListThreadsRequestContent, NylasListThreadsResponseContent } from "@equaliq/api-model";
import { createApiRequest } from "../common";

/**
 * Request shape for listing threads. Superset of the api-model
 * NylasListThreadsRequestContent (closed object, no index signature) with the
 * R1-a escape-hatch flag the api-server reads off the raw request body.
 *
 * `includeUnlinked` is DEFAULT OFF: when absent/false the endpoint returns the
 * deal-only inbox byte-for-byte (only categorizer-linked threads). When true
 * ("Needs review / All mail" view) the server LEFT-joins instead — every Nylas
 * thread is kept, unlinked threads carry `linkState: "unlinked"` plus the
 * categorizer verdict/reason. The flag is NOT in the Smithy contract on purpose
 * (it's an inbox-recovery affordance, not typed CRUD); typia.assert ignores
 * excess properties and the route registry hands the raw body to the handler,
 * so this flows through without an api-model bump.
 */
export interface ListIntegrationThreadsRequest extends NylasListThreadsRequestContent {
  includeUnlinked?: boolean;
}

/**
 * API function to list threads with enriched metadata
 * @param request Thread list parameters (connectionId, filters, pagination, includeUnlinked)
 * @returns Promise with list of threads and pagination info
 */
export const listIntegrationThreadsApi = async (request: ListIntegrationThreadsRequest): Promise<NylasListThreadsResponseContent> => {
  const apiRequest = createApiRequest<NylasListThreadsResponseContent>('post', '/integrations/nylas/threads/list');
  return apiRequest(request);
};
